import { TYPE_COLORS } from '../mock/data.ts';

// Pokémon-type chip using the canonical type colors. These are conventions,
// not design choices — substituting brand colors here breaks audience trust.
export function TypeChip({ type, size = 'sm' }: { type: string; size?: 'sm' | 'md' }) {
  const color = TYPE_COLORS[type] ?? '#666';
  const isSmall = size === 'sm';
  return (
    <span
      className="caps"
      style={{
        display: 'inline-block',
        padding: isSmall ? '1px 6px' : '2px 8px',
        background: `${color}26`, // 15% alpha
        color,
        border: `1px solid ${color}55`,
        borderRadius: 2,
        fontSize: isSmall ? 9 : 11,
        lineHeight: 1.4,
        letterSpacing: '0.08em',
      }}
    >
      {type}
    </span>
  );
}
